'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'truck-medical';
var width = 640;
var height = 512;
var aliases = [128657,"ambulance"];
var unicode = 'f0f9';
var svgPathData = 'M232 64C249.7 64 264 78.33 264 96V120H288C305.7 120 320 134.3 320 152V200C320 217.7 305.7 232 288 232H264V256C264 273.7 249.7 288 232 288H184C166.3 288 152 273.7 152 256V232H128C110.3 232 96 217.7 96 200V152C96 134.3 110.3 120 128 120H152V96C152 78.33 166.3 64 184 64H232zM184 152H128V200H184V256H232V200H288V152H232V96H184V152zM.0003 64C.0003 28.65 28.65 0 64 0H352C387.3 0 416 28.65 416 64V96H481.3C495.3 96 508.6 102.1 517.7 112.8L596.4 204.6C603.9 213.3 608 224.4 608 235.8V384H624C632.8 384 640 391.2 640 400C640 408.8 632.8 416 624 416H576C576 469 533 512 480 512C426.1 512 384 469 384 416H256C256 469 213 512 160 512C106.1 512 64 469 64 416C28.65 416 0 387.3 0 352L.0003 64zM352 32H64C46.33 32 32 46.33 32 64V352C32 369.7 46.33 384 64 384H69.46C82.64 346.7 118.2 320 160 320C201.8 320 237.4 346.7 250.5 384H384V64C384 46.33 369.7 32 352 32zM416 128V224H570.9L493.4 133.6C490.4 130 485.1 128 481.3 128H416zM480 320C521.8 320 557.4 346.7 570.5 384H576V256H416V344.4C432.1 329.2 455.4 320 480 320zM160 480C195.3 480 224 451.3 224 416C224 380.7 195.3 352 160 352C124.7 352 96 380.7 96 416C96 451.3 124.7 480 160 480zM480 352C444.7 352 416 380.7 416 416C416 451.3 444.7 480 480 480C515.3 480 544 451.3 544 416C544 380.7 515.3 352 480 352z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTruckMedical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;